import { BookOpen, Feather, FileDown, ListChecks, PenLine, Users } from "lucide-react"

const ICONS = {
  "list-checks": ListChecks,
  "pen-line": PenLine,
  "book-open": BookOpen,
  feather: Feather,
  "file-down": FileDown,
  users: Users,
} as const

export function FeatureIcon({ name, className }: { name: keyof typeof ICONS; className?: string }) {
  const Icon = ICONS[name]
  return <Icon className={className} strokeWidth={1.75} aria-hidden />
}
